/**
 * A helper service to validate the requirements the service has for passwords.
 * @ngesdoc service
 * @ngname passwords
 * @ngmodule common
 */
class Passwords {
  /**
   * Validate a password to make sure it meets the service requirements.
   * @param {string} password The password to validate.
   * @return {string} An empty string if passed the validation, or an error message if
   *                  something went wrong.
   */
  validate(password) {
    let error = '';
    const passwordMinLength = 8;
    if (password.length < passwordMinLength) {
      error = 'The password needs to be at least 8 characters long';
    } else if (!/[A-Z]/.test(password)) {
      error = 'The password needs to have at least one uppercase character';
    } else if (!/[a-z]/.test(password)) {
      error = 'The password needs to have at least one lowecase character';
    } else if (!/[0-9]/.test(password)) {
      error = 'The password needs to have at least one number';
    }

    return error;
  }
}

export default Passwords;
